import _ from "lodash";
import { Fragment, useEffect, useState } from "react";
import { Col, Container } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { FaLocationDot, FaMapLocation, FaUserLarge } from "react-icons/fa6";
import { PiMapPinAreaFill } from "react-icons/pi";
import { getMethod } from "../../../function/helper";
import usePage from "../../../hooks/usePage";
import Footer from "../../../modules/public/footer/footer";
import Menu from "../../../modules/public/menu/menu";
import styles from "./ActiveAgentList.module.css";
import AgentPhoneNumbers from "./AgentPhoneNumbers";

const ActiveAgentList = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  const [firstHalf, setFirstHalf] = useState([]);
  const [secondHalf, setSecondHalf] = useState([]);

  const getData = async () => {
    const response = await getMethod("/agent/v1/province-list");
    if (!response || response.status !== 200) {
      return;
    }

    const list = response.result?.map((item, index) => (
      <Accordion className="mb-3" key={index}>
        <Accordion.Item eventKey={index}>
          <Accordion.Header className={styles.accordionButton}>
            {item.faName}
          </Accordion.Header>
          <Accordion.Body>
            {item.agent_list.map((item, index) => (
              <Fragment key={index}>
                {index > 0 && (
                  <hr
                    style={{ height: 2, backgroundColor: "black" }}
                    className="mt-5"
                  />
                )}
                <div className="d-flex flex-wrap">
                  <div className="mt-5 me-3">
                    <FaMapLocation
                      style={{
                        width: 25,
                        height: 25,
                        color: "#ff6600",
                      }}
                    />
                    <span style={{ marginRight: 15 }}>{item.city.faName}</span>
                  </div>

                  <div className="mt-5 me-5">
                    <FaUserLarge
                      style={{
                        width: 25,
                        height: 25,
                        color: "#ff6600",
                      }}
                    />

                    <span style={{ marginRight: 15 }}>
                      {item.user.name} {item.user.family ?? ""}
                    </span>
                  </div>
                </div>

                <AgentPhoneNumbers item={item} />

                <div className="mt-4 mb-3 me-3">
                  <FaLocationDot
                    style={{
                      width: 25,
                      height: 25,
                      color: "#ff6600",
                    }}
                  />

                  {item.isTraveller === 0 ? (
                    <span style={{ marginRight: 15 }}>{item.address}</span>
                  ) : (
                    <span style={{ marginRight: 15 }}>سیار</span>
                  )}
                </div>

                {item.area.length > 0 && (
                  <div className="mt-4 mb-3 me-3">
                    <PiMapPinAreaFill
                      style={{
                        width: 25,
                        height: 25,
                        color: "#ff6600",
                      }}
                    />

                    {item.area.map((area, idx) => (
                      <div
                        style={{ marginRight: 15 }}
                        className="d-inline-block"
                        key={area.id}
                      >
                        {idx > 0 && <span> , </span>}
                        <span>{area.faName}</span>
                      </div>
                    ))}
                  </div>
                )}
              </Fragment>
            ))}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    ));

    const splitArray = _.chunk(list, Math.ceil(list.length / 2));
    setFirstHalf(splitArray[0]);
    setSecondHalf(splitArray[1] || []);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Fragment>
      <Menu />

      {pageSliders}

      <Container className="my-5" dir="rtl">
        {pageText}
      </Container>

      <Container className="rtl d-flex flex-wrap">
        <Col xs={12} md={6} className="px-1">
          {firstHalf.map(item => item)}
        </Col>
        <Col xs={12} md={6} className="px-1">
          {secondHalf.map(item => item)}
        </Col>
      </Container>

      {pageImage}

      <Footer />
    </Fragment>
  );
};

export default ActiveAgentList;
